
<div class="social">
    <a href="https://www.instagram.com/franarturduque/" target="_blank">
        <fa-icon [icon]="faInstagram"></fa-icon>
    </a>  
</div>
<div class="social">
    <a href="https://www.facebook.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faFacebookF"></fa-icon>
    </a>  
</div>
<div class="social">
    <a href="https://twitter.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faTwitter"></fa-icon>
    </a>   
</div>
<div class="social">
    <a href="https://www.youtube.com/FranarturDuque/" target="_blank">
        <fa-icon [icon]="faYoutube"></fa-icon>
    </a>    
</div>
